import inputBorderSecondary from '../../input/border-color/default/secondary';

const secondary = (params) => inputBorderSecondary(params);

export default secondary;
